export const GET_ORDERS = 'GET_ORDERS'
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS'
export const GET_ORDERS_FAIL = 'GET_ORDERS_FAIL'

export const GET_ORDER_VIEW = 'GET_ORDER_VIEW'
export const GET_ORDER_VIEW_SUCCESS = 'GET_ORDER_VIEW_SUCCESS'
export const GET_ORDER_VIEW_FAIL = 'GET_ORDER_VIEW_FAIL'
